import {alpha, styled} from '@mui/material/styles';

import {Box} from '@mui/material';

export const StyledAdornedEnd = styled('div')(({theme}) => ({
  color: alpha(theme.palette.text.secondary, 0.7),
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
}));

export const StyledSpacerRow = styled('div')(({theme}) => ({
  position: 'relative',
  display: 'block',
  height: theme.spacing(2),
}));

export const StyledSpacerRowSmall = styled('div')(({theme}) => ({
  position: 'relative',
  display: 'block',
  height: theme.spacing(1),
}));

export const StyledDatesContainer = styled(Box)(({theme}) => ({
  backgroundColor: alpha(theme.palette.background.default, 0.5),
  borderColor: alpha(theme.palette.text.secondary, 0.2),
}));

export const StyledHelperTypography = styled(Box)(({theme}) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0),
}));
